module.exports = __webpack_public_path__ + "static/media/BlixLogo.4f388121.avif";